

export const PARTNER_LINKS_PATH = "/partner/links"

export const PARTNER_LINK_VORLAGEN = "/partnerlinkvorlagen"

export const partnerKundeLinks = (vorlagen, discriminator, modelId) => {
    const vorlage = vorlagen?.[discriminator]
    if (!vorlage || !modelId) return {}
    const id = encodeURIComponent(modelId)
    return Object.entries(vorlage).reduce((links, [name, link]) => {
        if (!link?.href) return links
        links[name] = {...link, href: link.href.replace(/\{modelId\}/g, id)}
        return links
    }, {})
}
